import { HotConnectedPortalPage as PortalPage } from './PortalPage';
import { mountTarget } from '../components/mountable';

mountTarget(PortalPage, document.getElementById('portal-container'));
